import { cn } from "@/lib/utils";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  linkText?: string;
  onLinkClick?: () => void;
}

export function Toggle({ checked, onChange, label, linkText, onLinkClick }: ToggleProps) {
  return (
    <div className="flex items-start gap-3 py-3">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={cn(
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors",
          checked ? "bg-blue-500" : "bg-gray-300"
        )}
      >
        <span
          className={cn(
            "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform",
            checked ? "translate-x-5" : "translate-x-0"
          )}
        />
        {checked && (
          <svg className="absolute left-1 top-1 w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
            <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </button>
      <div className="flex-1 text-sm">
        <span>{label}</span>
        {linkText && onLinkClick && (
          <button
            type="button"
            onClick={onLinkClick}
            className="text-blue-500 underline ml-1"
          >
            {linkText}
          </button>
        )}
      </div>
    </div>
  );
}
